__webpack_require__.p = "https://bmidxbgermanyplprod.netlify.app/";